import { useTranslation } from 'react-i18next'

import { CheckCircleIcon, WarningIcon, XCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, helpers, returnStatuses, Text } from '@reveni-io/reveni-ui'

import MoreActionsMenu from './MoreActionsMenu/MoreActionsMenu'
import * as Styles from './styles'

const OnHoldCard = ({
  onHoldReason,
  onHoldTime,
  onAccept,
  onDecline,
  status,
  acceptingOnHold,
  decliningOnHold,
  allowsEditReturnStatus,
  allowsEditReturnLabels,
  onChangeDeliveryMethod,
  isChangeDeliveryMethodDisabled,
  onEditTransactionResult,
  editTransactionResultLabel,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (status !== returnStatuses.onHold) return null

  return (
    <Styles.MainContainer>
      <Styles.ExceptionHeader>
        <WarningIcon size={14} />
        <Text type="allCapsS" customStyles={{ textTransform: 'uppercase' }}>
          {t('Acción pendiente')}
        </Text>
      </Styles.ExceptionHeader>
      <Styles.Container>
        <Styles.AlertInfoContainer>
          <Text type="titleM">
            {t('En espera - Motivo')}: &quot;{onHoldReason}&quot;
          </Text>
          <Text type="bodySRegular" color={theme.colors.text.subtle}>
            {helpers.getRelativeTime(onHoldTime, t)}
          </Text>
        </Styles.AlertInfoContainer>
        <Styles.ActionsContainer>
          {allowsEditReturnStatus && (
            <>
              <Button color="success" size="s" onClick={onAccept} disabled={acceptingOnHold || decliningOnHold}>
                <CheckCircleIcon size={16} />
                {t('Aprobar solicitud')}
              </Button>
              <Button
                variant="outlined"
                size="s"
                color="danger"
                onClick={onDecline}
                disabled={acceptingOnHold || decliningOnHold}
              >
                <XCircleIcon size={16} color={theme.colors.danger.default} />
                {t('Rechazar solicitud')}
              </Button>
            </>
          )}
          <MoreActionsMenu
            allowsEditReturnLabels={allowsEditReturnLabels}
            isChangeDeliveryMethodDisabled={isChangeDeliveryMethodDisabled}
            onChangeDeliveryMethod={onChangeDeliveryMethod}
            onEditTransactionResult={onEditTransactionResult}
            editTransactionResultLabel={editTransactionResultLabel}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Styles.MainContainer>
  )
}

export default OnHoldCard
